export default "__VITE_ASSET__CO$BN5pN__"